import { redirect, RouteObject } from 'react-router-dom';

import i18n from 'app/i18n';
import { profiles } from 'app/services';
import { ModuleLayout } from 'app/layouts';

import Form from './form';
// import List from './list';

export const routes: RouteObject[] = [
  { path: 'profiles', element: <ModuleLayout />,
    handle: { title: i18n.t('profiles.title') },
    children: [
      // { path: '', index: true, element: <List />,
      //   handle: { permission: 'profiles:read', exclude: true },
      // },
      // { path: 'new', element: <Form />,
      //   handle: { title: i18n.t('profiles.new'), permission: 'profiles:create' },
      // },
      { path: '', index: true, loader: () => redirect('/users') },
      { path: ':id', element: <Form />,
        loader: ({ params: { id } }) => profiles.get(id!).then(({ data }) => data ?? redirect('..')),
        handle: { title: (profile: any) => (profile && i18n.t('profiles.edit', profile)), permission: 'profiles:update' },
      },
    ],
  },
];
